import { AxiosRequestConfig } from "axios";

export const makeSetAuthOnRequest = (
  getToken: () => Promise<string | null>
) => async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const token = await getToken();

  if (!token) {
    const controller = new AbortController();
    controller.abort();
    return { ...config, signal: controller.signal };
  }

  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    },
  };
};
